import styled from "styled-components";
import { Card } from "../../../../../components/Card";

export const SectionCard = styled(Card)`
  text-align: left;
  position: relative;
  border: 1px solid transparent;
  &:hover {
    border-color: ${(props) => props.color};
  }
  ${(props) =>
    props.$current &&
    `&:after {
    content: " ";
    position: absolute;
    right: -15px;
    top: 13px;
    border-top: 15px solid transparent;
    border-right: none;
    border-left: 15px solid ${props.color};
    border-bottom: 15px solid transparent;}`}
  ${(props) => props.$current && `border-color: ${props.color};`}
`;
